import React, { useState } from 'react'
import { Textarea } from '~/lib/ui/textarea'
import { Button } from '~/lib/ui/button'
import StarRating from './StarRating'
import { apiPatch } from '~/util/api'
import { useToast } from '~/lib/ui/toast'

const CandidateReviewFeedbackForm = ({
  choices,
  admonition,
  serviceRequestType,
  serviceRequestName,
  onSuccess,
}) => {
  const [rating, setRating] = useState(0)
  const [coachRating, setCoachRating] = useState(0)
  const [feedback, setFeedback] = useState('')
  const [errorVisible, setErrorVisible] = useState(false)

  const { toast } = useToast()

  const handleSubmit = async () => {
    if (rating === 0 || coachRating === 0) {
      setErrorVisible(true)
      return
    }

    setErrorVisible(false)

    const formData = new FormData()
    formData.append('feedback_service_request[rating]', rating)
    formData.append('feedback_service_request[coach_rating]', coachRating)
    formData.append('feedback_service_request[feedback]', feedback)
    formData.append(
      'feedback_service_request[service_request_type]',
      serviceRequestType,
    )
    formData.append('_method', 'patch') // Tell Rails to treat as PATCH

    try {
      const response = await apiPatch(
        '/coach_services/service_request_rating',
        formData,
      )
      onSuccess?.(response.data) // Close modal from parent
    } catch (error) {
      console.error('Error submitting feedback:', error)
      toast({
        title: 'Something went wrong',
        description: 'We couldn’t send your feedback. Please try again.',
        variant: 'destructive',
      })
    }
  }

  return (
    <form className="flex flex-col gap-6 p-8 pt-0">
      <div>
        <p className="text-md mb-2 font-medium">
          We value your feedback. How would you rate your{' '}
          {serviceRequestName.toLowerCase()}?
        </p>
        <StarRating
          choices={choices}
          value={rating}
          onChange={setRating}
          idPrefix="candidate"
        />
      </div>

      <div>
        <p className="text-md mb-2 font-medium">
          How would you rate your coach?
        </p>
        <StarRating
          choices={choices}
          value={coachRating}
          onChange={setCoachRating}
          idPrefix="coach"
        />
      </div>

      {errorVisible && (
        <div className="rounded-md border border-red-500 bg-red-100 px-4 py-2 text-sm text-red-800">
          Please select a star rating for both your{' '}
          {serviceRequestName.toLowerCase()} and your coach.
        </div>
      )}

      <p className="text-sm text-gray-600">{admonition}</p>

      <div>
        <Textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Additional feedback"
          aria-label="Feedback"
        />
      </div>

      <div className="flex justify-center gap-8 pt-2">
        <Button variant="coachcta" type="button" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="ghost" type="button" onClick={onSuccess}>
          No thanks
        </Button>
      </div>
    </form>
  )
}

export default CandidateReviewFeedbackForm
